module.exports = __webpack_public_path__ + "img/card_4.cc6e791c.svg";